import { useState } from 'react'
import { Prose } from './Prose'

/**
 * "Ana ekrana ekle" yönlendirmesi — iOS'a özel.
 *
 * Android/masaüstü Chrome kendi kurulum akışını gösteriyor; oraya kod yazmadık
 * çünkü bu paneli kullanan cihazların hepsi Apple. (Bir gün Android girerse
 * `beforeinstallprompt` olayıyla gerçek bir "Yükle" düğmesi eklenebilir.)
 *
 * iOS Safari kurulum çubuğu GÖSTERMİYOR ve hiç göstermeyecek — kullanıcı Paylaş
 * menüsünden elle eklemek zorunda. Bize kalan tek şey tarif etmek.
 *
 * Kurmamanın bedeli kozmetik değil: iOS'ta Web Push YALNIZCA ana ekrana
 * eklenmiş uygulamada çalışıyor (16.4+). Sekmede izin kutusu bile çıkmıyor.
 *
 * Bir kez kapatılınca geri gelmiyor — kapatmak da bir cevap.
 */

const KEY = 'kilo.installhint.v1'

/** Ana ekrandan mı açıldı? iOS eski `navigator.standalone`u, gerisi media query'yi kullanıyor. */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false
  const legacy = (window.navigator as unknown as { standalone?: boolean }).standalone
  return legacy === true || window.matchMedia('(display-mode: standalone)').matches
}

export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  // iPadOS 13+ kendini Mac gibi tanıtıyor; dokunmatik nokta sayısı ayırt ediyor.
  return /iPad|iPhone|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1)
}

export function InstallHint() {
  const [gizli, setGizli] = useState(() => {
    try { return localStorage.getItem(KEY) === '1' } catch { return false }
  })

  if (gizli || !isIos() || isStandalone()) return null

  const kapat = () => {
    try { localStorage.setItem(KEY, '1') } catch { /* yok say */ }
    setGizli(true)
  }

  return (
    <div className="card installhint">
      <h2>📲 Ana ekrana ekle</h2>
      <p className="sub">
        Ekranın altındaki <strong>Paylaş</strong> ikonuna dokun — kutudan çıkan
        yukarı ok. Açılan listeyi aşağı kaydır, <strong>Ana Ekrana Ekle</strong>{' '}
        yazanı seç. Panel kendi ikonuyla açılır, adres çubuğu gitmez.
      </p>
      {/* Prose: telefonda uzun metin iki satıra kırpılıyor ve "devamını oku"
          düğmesi çıkıyor. Düz <p className="note"> kullanılsaydı metin üç nokta
          ile kesilir, açmanın yolu olmazdı. */}
      <Prose className="note" style={{ marginBottom: 12 }}>
        Bildirim istersen bu şart: <strong>hatırlatmalar iPhone'da yalnızca ana
        ekrana eklenmiş uygulamada çalışıyor.</strong> Safari sekmesinde izin bile
        istenemiyor — Apple'ın kuralı, bizim tercihimiz değil.
      </Prose>
      <button onClick={kapat}>Anladım, bir daha gösterme</button>
    </div>
  )
}
